import type { UseReportPageHeadResult } from '@/domains/investor/types/report.types'
import type { HeadLink, HeadMeta, I18nParams, IAdaptReport } from '@/types/shared-types'

export default function useArticlePageHead(report: IAdaptReport): UseReportPageHeadResult {

  const { t } = useI18n()
  const baseUrl = 'https://www.benefitsystems.pl'

  const getPageTitle = () => {
    return report?.title || t('pageTitles.report.title') || ''
  }

  const getPageLink = () => {
    const link: HeadLink[] = []
    link.push({
      hid: 'favicon',
      rel: 'icon',
      type: 'image/x-icon',
      href: '/favicon.ico',
    })

    link.push({
      rel: 'canonical',
      href: `${baseUrl}${report.url}`,
    })

    Object.entries(report!.urlsByIsoCode).forEach(([key, value]) => {
      const langKey = key === 'pl-PL' ? 'pl' : 'en'
      link.push({
        rel: 'alternate',
        hreflang: langKey,
        href: `${baseUrl}${report.urlsByIsoCode[key]}`,
      })
    })

    link.push({
      rel: 'alternate',
      hreflang: 'x-default',
      href: `${baseUrl}${report?.url}`,
    })

    return link
  }

  const getPageMeta = () => {
    const meta: HeadMeta[] = []

    meta.push({
      name: 'description',
      content: report?.description || '',
    })

    return meta
  }

  const get18nParams = () => {
    const I18nParams: I18nParams = {}
    
    Object.entries(report!.urlsByIsoCode).forEach(([key, value]) => {
      const langKey = key === 'pl-PL' ? 'pl' : 'en'
      I18nParams[langKey] = {url: value}
    })

    return I18nParams
  }

  return {
    title: getPageTitle(),
    link: getPageLink(),
    meta: getPageMeta(),
    I18nParams: get18nParams(),
  }
}
